import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Injector, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren, WritableSignal, booleanAttribute, runInInjectionContext } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { ErrorService } from '../../../../core/services/error.service';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    AsyncPipe
  ]
})
export class InputTextComponent implements OnInit {// OnChanges {
  @Input() name: string = '';
  @Input() label?: string;
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() type: string = 'text';
  @Input() class: string = '';
  @Input() step?: number;
  @Input() min?: number;
  @Input() max?: number;
  @Input({ transform: booleanAttribute }) clearable: boolean = false;
  @Input({ transform: booleanAttribute }) readonly: boolean = false;
  @Input() autocompleteOptions: WritableSignal<any[]> | null = null;
  @Input() autocompleteLabelField: string = '';
  @Input() autocompleteValueField?: string;
  @Input() labelError?: string;
  @Input() integer?:boolean=false
  @Input({ transform: booleanAttribute }) hasCustomPrefix: boolean = false;
  @ViewChildren(MatInput) myInput!: QueryList<MatInput>;
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  constructor(
    private errorService: ErrorService,
    private injector: Injector
  ) {}

  ngOnInit(): void {
    runInInjectionContext(
      this.injector,
      () => {
        if (this.autocompleteOptions) {
          toObservable(this.autocompleteOptions).subscribe(() => {
            if (this.autocompleteOptions && this.autocompleteOptions().length > 0 && !(this.autocompleteOptions().length === 1 && this.autocompleteOptions()[0][this.autocompleteValueField ?? ''] === this.form.get(this.name)?.value)) {
              this.openAutocomplete();
            }
          });
        }
      }
    )
  }
  checkNumberValue(e:any){

    if(this.type=='number' && this.form.get(this.name)?.value<0){
      this.form.get(this.name)?.reset()
    }
    if(this.type=='number' && this.integer==true && this.form.get(this.name)?.value!== null){
      this.form.get(this.name)?.setValue(parseInt(this.form.get(this.name)?.value))
    }
    //controllo nel caso di creazione di controllo singolo
    if(this.type=='number' && this.integer==true && this.form.get(this.name)?.value== null){
      if (e.data === ',') {
        e.target.value = e.target.value.slice(0, -1);  
      }
      if (e.data === '.') {
        e.target.value = e.target.value.slice(0, -1);  
      }
    }
  }
  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.labelError ?? this.label?.replace('*', '') ?? this.name, errors);
  }

  get isDirty() {
    return this.form.get(this.name)?.dirty;
  }

  clear() {
    this.form.get(this.name)?.reset()
  }

  onBlur(event: any) {
    if (this.type === 'number'){
      this.form.get(this.name)?.setValue(parseFloat(event.target.value));
    }
  }

  openAutocomplete() {
    this.autocomplete.openPanel();
  }
}
